import React, { Component } from "react";
import { Card, Table, Button, FormControl } from "react-bootstrap";
import key from "../../../config/key.json";
import { toast } from "react-toastify";
import { getFromStorage } from "../../../utils/storage";
import errorConfig from "../../../config/errorConfig.json";
import { withRouter } from "react-router";
import { CircularProgress } from "@material-ui/core";
import { VideoCall, CloudUpload, CloudDownload } from "@material-ui/icons";
import moment from "moment";
import UploadPrescription from "./UploadPrescription";
import axios from "axios";
import api from "../../../config/api.json";
import imageCompression from "browser-image-compression";
import fire from "../../../firebase/fire";
import { getToken, getNotifications } from "../saveToken";
import { connect } from "react-redux";

const color = "#229a88";

class Call extends Component {
  state = {
    isLoading: true,
    show: false,
    base64: "",
    files: [],
    isUploading: false,
    downloadedPrescription: null,
    presignedURL: "",
    fields: "",
    isDownloading: false,
  };

  //Download Prescription
  downloadPrescription = () => {
    if (getFromStorage(key.loginInfoKey).task === "patient") {
      this.setState({ isDownloading: true }, () => {
        const body = {
          task: "getCurrentPrescription",
          appointment_id: this.props.location.pathname.split("/")[
            this.props.location.pathname.split("/").length - 2
          ],
        };
        const headers = { headers: { "Content-Type": "application/json" } };
        axios
          .post(api.PatientApi, body, headers)
          .then((res) => {
            if (res.data) {
              this.setState({ downloadPrescription: res.data }, () => {
                window.location = res.data;
              });
            } else {
              this.notifyError("Could not download no file");
            }
            this.setState({ isDownloading: false });
          })
          .catch((err) => {
            this.notifyError(err.toString());
            this.setState({ isDownloading: false });
          });
      });
    } else {
      this.notifyError("No file is there to download");
    }
  };

  getPresignedUrl = () => {
    const body = {
      task: "uploadCurrentPrescription",
      appointment_id: this.props.location.pathname.split("/")[
        this.props.location.pathname.split("/").length - 2
      ],
    };
    const headers = { headers: { "Content-Type": "application/json" } };
    axios
      .post(api.DoctorApi, body, headers)
      .then((res) => {
        if (!res.data.errorMessage) {
          this.setState({
            presignedURL: res.data.url,
            fields: res.data.fields,
          });
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.notifyError(err.toString());
        this.setState({ isLoading: false });
      });
  };

  //Upload prescription
  uploadPrescription = () => {
    if (getFromStorage(key.loginInfoKey).task === "doctor") {
      this.setState({ isUploading: true }, () => {
        const formData = new FormData();
        const arr = Object.keys(this.state.fields);

        arr.forEach((key) => {
          formData.append(key, this.state.fields[key]);
        });
        formData.append("file", this.state.files);

        axios
          .post(this.state.presignedURL, formData)
          .then((res) => {
            if (!res.data.errorMessage) {
              this.notifySuccess("Prescription Uploaded Successfully");
              this.setState({ show: false, files: [], base64: "" });
            } else {
              this.notifyError("Can not upload");
            }
            this.setState({ isUploading: false });
          })
          .catch((err) => {
            this.notifyError(err.toString());
            this.setState({ isUploading: false });
          });
      });
    }
  };

  //Notification Request
  notificationRequest = (token, type, id, notification_id) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization:
        "key=AAAAcHXSJak:APA91bFW5NnyfjZx4wYC7soTVuCblryMMawUSVAGezx_E4NVLtB50BF6orjSwvUoTztk4o43JrjGvYM3rx_JgpMErpTPBA6xpe8hHfuyKCSOG9OohBkE2hQNeHMt7mlRHnjwsn12Vr5Z",
    };
    const body = {
      notification: {
        title: "SemDoc",
        body:
          type === "doctors"
            ? `Doctor is calling you and waiting for you at appointment id ${
                this.props.location.pathname.split("/")[
                  this.props.location.pathname.split("/").length - 3
                ]
              }`
            : `Patient is calling you and waiting for you at appointment id ${
                this.props.location.pathname.split("/")[
                  this.props.location.pathname.split("/").length - 3
                ]
              }`,
      },
      data: {
        id,
        notification_id,
        type,
      },
      to: token,
    };

    fetch("https://fcm.googleapis.com/fcm/send", {
      method: "POST",
      body: JSON.stringify(body),
      headers,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success === 1) {
        }
      })
      .catch((err) => {
        console.log(err.response);
        this.notifyError(err.toString());
      });
  };

  //Send notification
  sendNotification = (type, id) => {
    fire
      .database()
      .ref(`${type}/${id}`)
      .once("value")
      .then((snapshot) => {
        if (snapshot.val()) {
          let notification = fire
            .database()
            .ref("notifications")
            .push({
              body:
                type === "doctors"
                  ? `Doctor is calling you and waiting for you at appointment id ${
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 3
                      ]
                    }`
                  : `Patient is calling you and waiting for you at appointment id ${
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 3
                      ]
                    }`,
              create_date: new Date().toISOString(),
              patient_id:
                type === "doctors"
                  ? this.props.location.pathname.split("/")[
                      this.props.location.pathname.split("/").length - 1
                    ]
                  : getFromStorage("patient"),
              doctor_id:
                type === "doctors"
                  ? getFromStorage("patient")
                  : this.props.location.pathname.split("/")[
                      this.props.location.pathname.split("/").length - 1
                    ],
              appointment_id: this.props.location.pathname.split("/")[
                this.props.location.pathname.split("/").length - 3
              ],
              time: this.props.location.pathname.split("/")[
                this.props.location.pathname.split("/").length - 2
              ],
              read: false,
            });
          if (snapshot.val().tokens) {
            snapshot
              .val()
              .tokens.map((token) =>
                this.notificationRequest(token, type, id, notification.key)
              );
          }
          if (snapshot.val().notifications) {
            let arr = snapshot.val().notifications;
            arr.push(notification.key);
            fire
              .database()
              .ref(`${type}/${id}`)
              .set({
                tokens: snapshot.val().tokens ? snapshot.val().tokens : [],
                notifications: arr,
              });
          } else {
            fire
              .database()
              .ref(`${type}/${id}`)
              .set({
                tokens: snapshot.val().tokens ? snapshot.val().tokens : [],
                notifications: [notification.key],
              });
          }
        } else {
          let notification = fire
            .database()
            .ref("notifications")
            .push({
              body:
                type === "doctors"
                  ? `Doctor is calling you and waiting for you at appointment id ${
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 3
                      ]
                    }`
                  : `Patient is calling you and waiting for you at appointment id ${
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 3
                      ]
                    }`,
              create_date: new Date().toISOString(),
              patient_id:
                type === "doctors"
                  ? this.props.location.pathname.split("/")[
                      this.props.location.pathname.split("/").length - 1
                    ]
                  : getFromStorage("patient"),
              doctor_id:
                type === "doctors"
                  ? getFromStorage("patient")
                  : this.props.location.pathname.split("/")[
                      this.props.location.pathname.split("/").length - 1
                    ],
              appointment_id: this.props.location.pathname.split("/")[
                this.props.location.pathname.split("/").length - 3
              ],
              time: this.props.location.pathname.split("/")[
                this.props.location.pathname.split("/").length - 2
              ],
              read: false,
            });
          fire
            .database()
            .ref(`${type}/${id}`)
            .set({
              tokens: [],
              notifications: [notification.key],
            });
        }
      })
      .catch((err) => this.notifyError(err.toString()));
  };

  //Set file for upload
  setFile = (data) => {
    this.setState(
      {
        files: data.length > 0 ? data[0].src.file : null,
        base64: data.length > 0 ? data[0].src.base64 : "",
      },
      () => {
        if (this.state.files) {
          const options = {
            maxSizeMB: 0.01,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          };
          imageCompression(this.state.files, options)
            .then((res) => {
              this.setState({ files: res });
            })
            .catch((err) => console.log(err));
        }
      }
    );
  };

  //Success Notification
  notifySuccess = (msg) => {
    toast.success("" + msg.toString());
  };

  //Error Notification
  notifyError = (error) => {
    toast.error("" + error.toString());
  };

  //First function run when page load
  componentDidMount() {
    toast.dismiss();
    if (!getFromStorage(key.loginInfoKey)) {
      this.notifyError(errorConfig.notLoggedInError);
      this.props.history.push("/");
    } else if (
      getFromStorage(key.loginInfoKey).task === "authAdmin" ||
      getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel"
    ) {
      this.props.history.push("/Graph");
    } else if (getFromStorage(key.loginInfoKey).task === "patient") {
      getNotifications(this.props.dispatch, this.props.notifications);
      getToken("patients");
      this.setState({ isLoading: false });
    } else if (getFromStorage(key.loginInfoKey).task === "doctor") {
      getNotifications(this.props.dispatch, this.props.notifications);
      getToken("doctors");
      this.getPresignedUrl();
    } else if (getFromStorage(key.loginInfoKey).task === "provider") {
      this.props.history.push("/provider_doctors");
    }
  }

  render() {
    const time = this.props.location.pathname.split("/")[
      this.props.location.pathname.split("/").length - 2
    ];
    if (this.state.isLoading) {
      return (
        <div
          style={{
            marginLeft: this.props.isOpened ? "160px" : "20px",
            marginTop: "70px",
            textAlign: "center",
          }}
        >
          <CircularProgress />
        </div>
      );
    }
    return (
      <div
        style={{
          marginLeft: this.props.isOpened
            ? window.innerWidth > 560
              ? "160px"
              : "20px"
            : "20px",
          marginTop: "70px",
          marginRight: "20px",
        }}
      >
        <Card
          style={{ padding: "20px", fontSize: "14px" }}
          className="shadow-4"
        >
          <div style={{ overflow: "auto" }}>
            <UploadPrescription
              show={this.state.show}
              base64={this.state.base64}
              setFile={this.setFile}
              isUploading={this.state.isUploading}
              handleClose={() =>
                this.setState({ show: false, files: [], base64: "" })
              }
              uploadPrescription={this.uploadPrescription}
            />
            <table>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Time:</td>
                  <td>
                    {moment(
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 2
                      ],
                      "YYYYMMDDhhmmss"
                    ).format("DD/MM/YYYY hh:mm A")}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Call Duration:</td>
                  <td>5 minutes</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Cost:</td>
                  <td>32</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Doctor:</td>
                  <td>
                    {
                      this.props.location.pathname.split("/")[
                        this.props.location.pathname.split("/").length - 1
                      ]
                    }
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Prescription:</td>
                  <td></td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Lab Reports:</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <ul className="list_call">
              <li>
                <FormControl type="text" placeholder="comment" />
              </li>
            </ul>
            <div style={{ textAlign: "center" }}>
              <Button
                onClick={() => {
                  window.open(`http://localhost:3000/#/permission`);
                }}
                size="sm"
                variant="success"
                style={{
                  margin: "5px",
                  width: "170px",
                  color: "white",
                  textTransform: "none",
                }}
              >
                <VideoCall fontSize="small" />
                <span style={{ marginLeft: "5px" }}>Test Video Audio</span>
              </Button>
              {new Date() >= new Date(moment(time, "YYYYMMDDhhmmss")) &&
                new Date() <=
                  new Date(
                    moment(time, "YYYYMMDDhhmmss").add(60, "minutes")
                  ) && (
                  <Button
                    onClick={() => {
                      window.open(
                        `https://twilio.semionmed.com/?id=${
                          getFromStorage(key.loginInfoKey).task === "doctor"
                            ? getFromStorage("doctor")
                            : getFromStorage("patient")
                        }&appointment_id=${
                          this.props.location.pathname.split("/")[
                            this.props.location.pathname.split("/").length - 2
                          ]
                        }&date=${new Date(
                          moment(time, "YYYYMMDDhhmmss")
                        ).getDate()}&hour=${new Date(
                          moment(time, "YYYYMMDDhhmmss").add(60, "minutes")
                        ).getHours()}&minute=${new Date(
                          moment(time, "YYYYMMDDhhmmss").add(60, "minutes")
                        ).getMinutes()}`
                      );
                      if (getFromStorage(key.loginInfoKey).task === "doctor")
                        this.sendNotification(
                          "patients",
                          this.props.location.pathname.split("/")[
                            this.props.location.pathname.split("/").length - 1
                          ]
                        );
                      else
                        this.sendNotification(
                          "doctors",
                          this.props.location.pathname.split("/")[
                            this.props.location.pathname.split("/").length - 1
                          ]
                        );
                    }}
                    size="sm"
                    variant="success"
                    style={{
                      margin: "5px",
                      width: "170px",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    <VideoCall fontSize="small" />
                    <span style={{ marginLeft: "5px" }}>Call Now</span>
                  </Button>
                )}
              <Button
                size="sm"
                variant="primary"
                style={{ margin: "5px", width: "170px" }}
                onClick={() => this.setState({ show: true })}
              >
                <CloudUpload fontSize="small" />
                <span style={{ marginLeft: "5px" }}>Upload Prescription</span>
              </Button>

              <Button
                size="sm"
                variant="danger"
                disabled={this.state.isDownloading}
                style={{ margin: "5px", width: "170px" }}
                onClick={this.downloadPrescription}
              >
                <CloudDownload fontSize="small" />
                <span style={{ marginLeft: "5px" }}>
                  {!this.state.isDownloading ? "Download" : "Downloading..."}
                </span>
              </Button>
            </div>
            <br />
            <h4 style={{ color, textAlign: "center", fontWeight: "bold" }}>
              Call History
            </h4>
            <Table striped bordered hover size="sm">
              <thead>
                <tr style={{ color }}>
                  <th>#</th>
                  <th>Call Duration</th>
                  <th>Call Start Time</th>
                  <th>Call End Time</th>
                </tr>
              </thead>
              <tbody></tbody>
            </Table>
            <div style={{ textAlign: "center" }}>No Call History</div>
          </div>
        </Card>
      </div>
    );
  }
}

export default connect((state) => ({
  notifications: state.notifications,
}))(withRouter(Call));
